export const initState = {
  countries: [],
}
